import '@babel/polyfill'
import 'nodelist-foreach-polyfill'

export default () => {
  const benefits = document.querySelectorAll('[data-benefit]')

  benefits.forEach((benefit, index) => {
    const head = benefit.querySelector('[data-benefit-head]')

    head.addEventListener('click', () => {
      benefit.classList.toggle('-active')
    })
  })
}
